import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=5a7b7180&scoped=true&"
import script from "./emoji.vue?vue&type=script&lang=js&"
export * from "./emoji.vue?vue&type=script&lang=js&"
import style0 from "./emoji.vue?vue&type=style&index=0&id=5a7b7180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b7180",
  null
  
)

export default component.exports